export const DistrictTypeIdEnum = {
  lookupTypeId: 18,
};
